

const SearchNotFoundIcon = ({
  size = 26,
  color = "white",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M10.666 0.5C16.2379 0.5 20.832 5.08984 20.832 10.6562C20.832 13.1953 19.9038 15.4902 18.3398 17.2969L25.2803 24.1816C25.5734 24.4746 25.5734 25.0117 25.2803 25.3047C25.1336 25.4512 24.9377 25.5 24.7422 25.5C24.498 25.5 24.3028 25.451 24.1562 25.3047L17.2646 18.3711C15.4562 19.9336 13.1587 20.8125 10.666 20.8125C5.04537 20.8124 0.5 16.2714 0.5 10.6562C0.5 5.0899 5.04537 0.500088 10.666 0.5ZM10.666 2.0625C5.87626 2.06259 2.06445 5.91998 2.06445 10.6562C2.06445 15.4414 5.87626 19.2499 10.666 19.25C15.407 19.25 19.2686 15.4414 19.2686 10.6562C19.2686 5.91992 15.407 2.0625 10.666 2.0625ZM7.34766 7.33887C7.62387 7.06265 8.14208 7.02782 8.45312 7.33887L10.665 9.55078L12.875 7.34082C13.1513 7.06505 13.6686 7.0311 13.9795 7.3418C14.256 7.61828 14.2567 8.17105 13.9805 8.44727L11.7705 10.6572L13.9824 12.8691C14.2587 13.1455 14.2592 13.6973 13.9834 13.9736C13.6727 14.2843 13.1544 14.25 12.8779 13.9736L10.666 11.7617L8.45605 13.9717C8.14529 14.2822 7.62701 14.2471 7.35059 13.9707C7.03972 13.6597 7.0399 13.1759 7.35059 12.8652L9.55957 10.6553L7.34766 8.44434C7.03666 8.13334 7.03705 7.64961 7.34766 7.33887Z"
        fill={color}
      />
    </svg>
  );
};

export default SearchNotFoundIcon;
